import { Component, OnInit } from "@angular/core";
import { AuthService } from "@app/shared/auth.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styles: [],
})
export class ForgotPasswordComponent implements OnInit {
  slideConfig2 = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "0",
    slidesToShow: 1,
    speed: 500,
    dots: true,
  };

  email: string;
  mailsent: boolean = false;

  constructor(
    private authService: AuthService,
    private toasterService: ToastrService
  ) {}

  ngOnInit() {}

  validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  recoverPassword() {
    //call the recover password service
    if (this.email && this.validateEmail(this.email)) {
      this.authService.forgotPassword(this.email).subscribe(
        (res) => {
          console.log(res);
          if (res.errors) {
            let errorMessage = res?.errors[0]?.message
              ? res?.errors[0]?.message
              : "Some error occured";
            console.log("res");
            this.toasterService.error(errorMessage, "Error", {
              positionClass: "toast-top-right",
            });
          } else {
            this.toasterService.success(res?.msg, "Success", {
              positionClass: "toast-top-right",
            });
            this.mailsent = true;
          }
          this.loading = false;
        },
        (err) => {
          console.log("Some error occured");
          let errorMessage = err?.errors[0]?.message
            ? err?.errors[0]?.message
            : "Some error occured";
          console.log("res");
          this.toasterService.error(errorMessage, "Error", {
            positionClass: "toast-top-right",
          });
          this.loading = false;
        }
      );
    }else{
      this.toasterService.warning("Email is not valid", "Invalid", {
        positionClass: "toast-top-right",
      });
    }
  }

  loading: boolean = false;
}
